var failure = 0;
window.dt_chunk = function (table, data, action, page, per_page, post_data) {
    if (typeof action == 'undefined') {
        let wrapper = table.closest(".dataTables_wrapper");
        wrapper.find('.card-loader').removeClass('loading');
        return;
    }
    if (action.length < 1) {
        let wrapper = table.closest(".dataTables_wrapper");
        wrapper.find('.card-loader').removeClass('loading');
        return;
    }

    if (typeof table.data("chunk") !== 'undefined') {
        table.data("chunk").abort();
    }

    table.data("chunk", $.ajax({
        url: action,
        method: "POST",
        data: {
            data: post_data,
            page: page,
            perpage: per_page
        },
        success: function (response) {
            clearTimeout(table.data("timeout"));
            let timeout = setTimeout(() => {
                table.DataTable().draw();
                table.DataTable().columns.adjust();
            }, 10);
            table.data("timeout", timeout);
            if (response.length == 0) return;
            table.DataTable().rows.add(response);
            page++;
            dt_chunk(table, data, action, page, per_page, post_data);
        },
        error: function (response, status) {
            if (status == 'abort') return;
            failure++;
            if (failure > 30) {
                alert("Error loading content! Contact server admin or refresh page!");
                return;
            }
            dt_chunk(table, data, action, page, per_page, post_data);
        },
        complete: function () {
            let wrapper = table.closest(".dataTables_wrapper");
            wrapper.find('.card-loader').removeClass('loading');
        }
    }));

};

$.fn.dataTable.Api.register('row.addByPos()', function (data, index) {
    var currentPage = this.page();

    //insert the row
    this.row.add(data);

    //move added row to desired index
    var rowCount = this.data().length - 1,
        insertedRow = this.row(rowCount).data(),
        tempRow;

    for (var i = rowCount; i >= index; i--) {
        tempRow = this.row(i - 1).data();
        this.row(i).data(tempRow);
        this.row(i - 1).data(insertedRow);
    }

});

$.fn.dataTable.ext.buttons.add = {
    text: '<i class="fas fa-plus"></i>',
    action: function (e, dt, node, config) {

        var table = $(dt.table().node());

        popup_open("editor-" + table.data("id"));

        var display = $(".popup[data-type='editor-" + table.data("id") + "']");

        $.each(display.find("form"), function () {
            $(this).find("button[data-type='discard']").click();
        });

        $(window).trigger('dt-add-opened');
    }
};

$.fn.dataTable.ext.type.order['color-pre'] = function (data) {
    var input = $(data).find(".colorpicker").data("color");
    var order = 0;

    switch (input) {
        case "#ffff00": case "rgb(255, 255, 0)":
            //Yellow
            order = 2;
            break;
        case "#0000ff": case "rgb(0, 0, 255)":
            //Blue
            order = 4;
            break;
        case "#008000": case "rgb(0, 128, 0)":
            //Green
            order = 5;
            break;
        case "#ff0000": case "rgb(255, 0, 0)":
            //Red
            order = 1;
            break;
        case "rgba(0, 0, 0, 0)":
            order = 3;
            break;
        default:
            order = 3;
            break;
    }

    return order;
};

$.fn.dataTable.moment('MM/DD/YYYY');

window.dataTableInstance = function (table, columns = []) {
    $.each(table.find("[data-column]"), function () {
        var col = $(this).data("column");
        if (col == 'commands') {
            columns.push({
                "data": function (row, type, val, meta) {
                    if (row.hasOwnProperty('deleted_at') && row.deleted_at !== null) {
                        return '';
                    }

                    var buttons = '<div class="datatable-commands">';

                    if (typeof table.data("command_pre") !== 'undefined') {
                        try {
                            for (let command of table.data("command_pre")) {
                                buttons += '<a href="javascript:void(0);" class="btn btn-secondary datatable-command btn-icon" data-id="' + row.id +
                                    '" data-type="' + command.type + '"><i class="' + command.icon + '"></i></a>';
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    }

                    if (typeof table.data("view") !== 'undefined') {
                        buttons += '<a href="' + table.data("view") + row.id + '" class="btn btn-secondary datatable-command btn-icon" data-id="' + row.id + '" data-type="add"><i class="far fa-eye"></i></a>';
                    }

                    if (typeof table.data("details") !== 'undefined') {
                        buttons += `
                            <a href="javascript:;" class="btn btn-secondary datatable-command btn-icon" data-id="${row.id}" data-type="details">
                              <i class="fas fa-list-alt"></i>
                            </a>
                        `;
                    }

                    if (typeof table.data("sync") !== 'undefined') {
                        buttons += '<a href="#" class="btn btn-secondary datatable-command btn-icon" data-id="' + row.id + '" data-type="sync"><i class="fas fa-sync"></i></a>';
                    }

                    if (typeof table.data("edit") !== 'undefined') {
                        buttons += '<a href="#" class="btn btn-secondary datatable-command btn-icon" data-id="' + row.id + '" data-type="edit"><i class="fas fa-pencil-alt"></i></a>';
                    }

                    if (typeof table.data("delete") !== 'undefined') {
                        let btnClassName = typeof table.data("delete-btn-danger") !== 'undefined' ? 'btn-danger' : 'btn-secondary';
                        buttons += '<a href="#" class="btn ' + btnClassName + ' datatable-command btn-icon" data-id="' + row.id + '" data-type="delete"><i class="fas fa-trash-alt"></i></a>';
                    }

                    if (typeof table.data("command_post") !== 'undefined') {
                        try {
                            for (let command of table.data("command_post")) {
                                buttons += '<a href="#" class="btn btn-secondary datatable-command btn-icon" data-id="' + row.id +
                                    '" data-type="' + command.type + '"><i class="' + command.icon + '"></i></a>';
                            }
                        } catch (e) {

                        }
                    }

                    if (typeof table.data('update_request') !== 'undefined') {
                        buttons += `<a href="javascript:;" class="btn btn-secondary datatable-command" data-requestable_id="${row.requestable_id}" data-requestable_type="${row.requestable_type}" data-type="update_request">Approve</a>`;
                    }

                    if (typeof table.data('update_request_reject') !== 'undefined') {
                        buttons += `<button type="button" data-requestable_id="${row.requestable_id}" data-requestable_type="${row.requestable_type}" class="btn btn-danger btn-dismiss ml-1">Reject</button>`;
                    }

                    if (typeof table.data('assign-contact') !== 'undefined') {
                        let isManagers = table.data('assign-contact') === 'managers';
                        buttons += isManagers || row.is_manager ? `<button title="Assign contact" type="button" class="btn btn-secondary datatable-command btn-icon" data-id="${row.id}" data-type="assign-contact">
                            <i class="fas fa-user-plus"></i>
                        </button>` : '';
                    }

                    if (typeof table.data('unassign') !== 'undefined') {
                        buttons += `<button title="Unassign" type="button" class="btn btn-warning datatable-command btn-icon" data-id="${row.id}" data-type="unassign">
                            <i class="fas fa-unlink"></i>
                        </button>`;
                    }

                    if (typeof table.data('unassign-contact') !== 'undefined') {
                        buttons += `<button title="Unassign contact" type="button" class="btn btn-warning datatable-command btn-icon" data-id="${row.id}" data-office_id="${table.data('office_id') || 0}" data-manager_id="${row.manager_id || 0}" data-type="unassign-contact">
                            <i class="fas fa-unlink"></i>
                        </button>`;
                    }

                    if (typeof table.data('archive') !== 'undefined' && row.hasOwnProperty('archived_at')) {
                        // unarchive
                        if (row.archived_at !== null) {
                            buttons += `<button type="button" class="btn btn-secondary datatable-command btn-icon" data-id="${row.id}" data-type="unarchive">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M4 21h16V8H4m10 7v3h-4v-3H7l5-5l5 5M3 3h18v4H3"/></svg>
                            </button>`;
                        }
                        // archive
                        else {
                            buttons += `<button type="button" class="btn btn-warning datatable-command btn-icon" data-id="${row.id}" data-type="archive">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M3 3h18v4H3V3m1 18V8h16v13H4m10-7v-3h-4v3H7l5 5l5-5h-3Z"/></svg>
                            </button>`;
                        }
                    }

                    if (typeof table.data('delete-and-reassign') !== 'undefined') {
                        buttons += `<button type="button" class="btn btn-danger datatable-command btn-icon" data-id="${row.id}" data-type="delete-and-reassign">
                            <i class="fas fa-trash-alt"></i>
                        </button>`;
                    }

                    buttons += '</div>';

                    return buttons;
                }
            });
        } else {
            columns.push({ "data": col });
        }
    });

    var data = [];

    var buttons = [];

    if (typeof table.data("add") !== 'undefined') {
        buttons.push("add");
    }

    var dom = '<"card-loader loading"><"d-flex card-header p-2"flB>r<"card-body p-0 dt-card-body"<"dt-table-wrapper"<"dt-sticky-header"> t>ip>';

    if (typeof table.data("dom") !== 'undefined') {
        dom = table.data("dom");
    }

    var emptyTable = 'No Records Found';

    if (typeof table.data("empty") !== 'undefined') {
        emptyTable = table.data("empty");
    }

    let defaults = {
        iDisplayLength: 100,
        searchDelay: 400,
        data: data,
        columns: columns,
        dom: dom,
        responsive: true,
        orderClasses: false,
        buttons: buttons,
        language: {
            lengthMenu: '<select class="select2">' +
                '<option value="25">Show 25</option>' +
                '<option value="50">Show 50</option>' +
                '<option value="100">Show 100</option>' +
                '<option value="250">Show 250</option>' +
                '<option value="500">Show 500</option>' +
                '<option value="1000">Show 1000</option>' +
                '</select>',
            search: '_INPUT_',
            searchPlaceholder: 'Search',
            emptyTable: emptyTable
        },
        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        },
        fnDrawCallback: function () {
            let wrapper = table.closest(".dataTables_wrapper");

            if (wrapper.find(".paginate_button").length < 4) {
                wrapper.find(".dataTables_paginate").hide();
            } else {
                wrapper.find(".dataTables_paginate").show();
            }

            wrapper.find('.card-loader').html(`
                <div class="loading-spinner-circle">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

                <div class="spinner-text">Fetching data...</div>
            `);
        },
        initComplete: function () {
            setTimeout(function () {
                $(window).trigger('tableLoaded', [table]);
            }, 500);
        },
        deferRender: true
    };

    if (urlParams.has('s')) {
        defaults.oSearch = {
            sSearch: urlParams.get("s")
        };
    }

    $.extend($.fn.dataTable.defaults, defaults);

    let options = typeof table.data("options") == 'undefined' ? {} : table.data("options");
    let dt = table.DataTable(options);

    $(window).trigger("dataTableInit.limelight", [dt]);

    var post_data = {};
    if (typeof table.data("post_data") !== 'undefined') {
        post_data = table.data("post_data");
    }

    if (typeof table.data("ext-buttons") !== 'undefined') {
        if ($('#buttons').length) {
            let buttons = new $.fn.dataTable.Buttons(dt, {
                buttons: [
                    { extend: "excel", text: '<i class="fas fa-file-download"></i>' }
                ]
            }).container().appendTo($('#buttons'));
        }
    }

    if (typeof table.data("ext-buttons-alt") !== 'undefined') {
        if ($(table.data("ext-buttons-alt")).length) {
            new $.fn.dataTable.Buttons(dt, {
                buttons: [
                    { extend: "excel", text: '<i class="fas fa-file-download"></i>' }
                ]
            }).container().appendTo($(table.data("ext-buttons-alt")));
        }
    }

    if (typeof table.data("server_data") !== 'undefined') {
        let td = _.get(window, table.data("server_data"));
        if (typeof td == 'undefined') td = [];
        dt.rows.add(td);
        dt.draw();
        dt.columns.adjust();
        let wrapper = table.closest(".dataTables_wrapper");
        wrapper.find('.card-loader').removeClass('loading');
        return;
    }

    dt_chunk(table, data, table.data("action"), 0, 10000, post_data);
}

function table_load(tables, i = 0) {
    setTimeout(() => {
        if (typeof tables[i] == 'undefined') return;
        let table = tables[i];
        dataTableInstance($(table));
        i++;
        table_load(tables, i);
    }, 100);
}

let tables = $(".data-table");
table_load(tables);

function formattedData(type, data, isEven = false) {
    if (type === 'ip_address') {
        let html = `
            <table class="table-child ${isEven ? 'even' : 'odd'}">
                <thead>
                    <tr>
                        <td>IP Address</td>
                        <td>Last Login</td>
                        <td>Browser Agent</td>
                        <td>Added By</td>
                        <td>Added At</td>
                    </tr>
                </thead>
                <tbody>
        `;

        for (let i = 0; i < data.ip_addresses.length; i++) {
            const ip_address = data.ip_addresses[i];

            html += `
                <tr>
                    <td>${ip_address.ip}</td>
                    <td>${ip_address.last_logged_in_at !== null ? ip_address.last_logged_in_at : '-'}</td>
                    <td>${ip_address.user_agent !== null ? ip_address.user_agent : '-'}</td>
                    <td>${ip_address.added_by !== null ? ip_address.added_by.name : '-'}</td>
                    <td>${ip_address.created_at}</td>
                </tr>
            `;
        }

        html += '</tbody></table>';

        return html;
    }

    return '';
}

let popupAlert = undefined;
$(window).on("dataTableInit.limelight", function (e, dt) {
    let table = $(dt.table().node());

    $(dt.table().node()).data("toggle_edit", function (id) {
        var display = $(".popup[data-type='editor-" + table.data("id") + "']");
        let loader = display.find(".popup-loader");
        loader.css("display", "flex");
        $.ajax({
            url: table.data("edit"),
            method: "POST",
            data: { id: id },
            dataType: 'json',
            success: function (response) {
                form_populate(display, response);
                $(window).trigger(table.data("edit") + ".fetched", [response]);

                // Set focus to address autocomplete, then blur it after that
                const addressAutocompleteComponent = display.find('.address-autocomplete');
                if (addressAutocompleteComponent.length) {
                    addressAutocompleteComponent.trigger('focus');

                    setTimeout(() => {
                        addressAutocompleteComponent.trigger('blur')
                        popup_open("editor-" + table.data("id"), {
                            response: response,
                            isEdit: true
                        });
                    }, 100);
                } else {
                    popup_open("editor-" + table.data("id"), {
                        response: response,
                        isEdit: true
                    });
                }
            },
            error: function (response) {
                message("Something went wrong!", 1);
            },
            complete: function () {
                loader.hide();
            }
        });
    });

    $(dt.table().node()).data("toggle_update_request", function (requestable_id, requestable_type) {
        var display = $(".popup[data-type='editor-" + table.data("id") + "']");
        let loader = display.find(".popup-loader");
        loader.css("display", "flex");
        $.ajax({
            url: table.data("update_request"),
            method: "POST",
            data: { requestable_id, requestable_type },
            dataType: 'json',
            success: function (response) {
                form_populate(display, response['update_requests'][response['update_requests'].length - 1]);
                $(window).trigger(table.data("update_request") + ".fetched", [response]);
                popup_open("editor-" + table.data("id"));
            },
            error: function (response) {
                message("Something went wrong!", 1);
            },
            complete: function () {
                loader.hide();
            }
        })
    });

    /* Datatable Command/Action List */
    function initCommandActions() {
        $(dt.table().node()).on('click', '.datatable-command', function () {
            var type = $(this).data('type');
            var table = $(this).closest('.data-table');

            switch (type) {
                case 'edit':
                    popupAlert = undefined;
                    $(dt.table().node()).off('click', '.datatable-command');
                    initCommandActions();
                    table.data('toggle_edit')($(this).data('id'));
                    break;
                case 'delete':
                    if (typeof table.data('replace') !== 'undefined') {
                        popup_open('editor-' + table.data('replace') + '_replace');
                        app.delete_id = $(this).data('id');
                        app.table_id = $(this).parents('table').attr('id');
                        break;
                    }
                    if (typeof popupAlert !== 'undefined') {
                        popupAlert.popover('dispose');

                        // if (popupAlert.data('id') == $(this).data('id')) {
                        //     popupAlert = undefined;
                        //     break;
                        // }
                    }

                    popupAlert = $(this);
                    $(this).popover({
                        'placement': 'left',
                        'template': popover_templates.confirm,
                        'title': 'Delete this record?',
                        'content': 'This can\'t be undone',
                        'delay': { 'show': 0, 'hide': 250 }
                    }).popover('show');
                    break;
                case 'details':
                    popupAlert = undefined;
                    let tr = $(this).closest('tr');
                    let row = table.DataTable().row(tr[0]);
                    let data = row.data();
                    let detailsType = table.data('details');

                    if (row.child.isShown()) {
                        row.child.hide();
                        tr.removeClass('shown');
                    } else {
                        row.child(formattedData(detailsType, data, tr.hasClass('even'))).show();
                        tr.addClass('shown');
                        tr.next('tr').find('td:first').addClass('p-0 border-0')
                    }
                    break;
                case 'update_request':
                    popupAlert = undefined;
                    table.data('toggle_update_request')($(this).data('requestable_id'), $(this).data('requestable_type'));
                    break;
                case 'archive':
                    // console.log('beforePopupAlertActive', popupAlert);

                    if (typeof popupAlert !== 'undefined') {
                        popupAlert.popover('dispose');
                        // console.log('activePopupAlert', popupAlert);
                        // console.log('oldAlert', popupAlert.data('id'));
                        // console.log('newAlert', $(this).data('id'));

                        // if (popupAlert.data('id') == $(this).data('id')) {
                        //     popupAlert = undefined;
                        //     break;
                        // }
                    }

                    popupAlert = $(this);
                    const a = $(this).popover({
                        'placement': 'left',
                        'template': popover_templates.archive_confirm,
                        'title': `Archive ${table.data('name') || 'record'} confirmation`,
                        'content': `Are you sure want to archive this ${table.data('name') || 'record'}?`,
                        'delay': { 'show': 0, 'hide': 250 }
                    }).popover('show');

                    // console.log('a', a)
                    break;
                case 'unarchive':
                    if (typeof popupAlert !== 'undefined') {
                        popupAlert.popover('dispose');

                        // if (popupAlert.data('id') == $(this).data('id')) {
                        //     popupAlert = undefined;
                        //     break;
                        // }
                    }

                    popupAlert = $(this);
                    $(this).popover({
                        'placement': 'left',
                        'template': popover_templates.unarchive_confirm,
                        'title': `Unarchive ${table.data('name') || 'record'} confirmation`,
                        'content': `Are you sure want to unarchive this ${table.data('name') || 'record'}?`,
                        'delay': { 'show': 0, 'hide': 250 }
                    }).popover('show');
                    break;
                case 'sync':
                    if (typeof popupAlert !== 'undefined') {
                        popupAlert.popover('dispose');
                    }

                    popupAlert = $(this);
                    $(this).popover({
                        'placement': 'left',
                        "template":popover_templates.confirm,
                        "title":"Sync data?",
                        "content":"Sync data to active placements?",
                        "delay":{"show":0, "hide":250}
                    }).popover('show');
                    break;
                case 'assign-contact':
                    let rowEle = $(this).closest('tr');
                    let rowTb = table.DataTable().row(rowEle[0]);
                    let rowTbData = rowTb.data();
                    let isManagers = table.data('assign-contact') === 'managers';
                    if (isManagers || rowTbData.is_manager) {
                        popup_open(`editor-assign_contact-${table.data('assign-contact')}`, rowTbData);
                        app_data.assign_contact.contact_id = null;
                        app_data.assign_contact.type = table.data('assign-contact');
                        app_data.assign_contact.office_id = isManagers ? $(this).data('id') : null;
                        app_data.assign_contact.manager_id = !isManagers ? $(this).data('id') : null;
                        app_data.assign_contact.table_id = $(this).parents('table').attr('id');
                    } else {
                        message("Cannot assign adjuster to a non-manager contact.", 1)
                    }
                    break;
                case 'unassign':
                case 'unassign-contact':
                    popupAlert = $(this);
                    $(this).popover({
                        'placement': 'left',
                        'template': popover_templates.confirm,
                        'title': 'Unassign this record?',
                        'content': 'This can\'t be undone',
                        'delay': { 'show': 0, 'hide': 250 }
                    }).popover('show');
                    break;
                case 'delete-and-reassign':
                    let rowEl = $(this).closest('tr');
                    let tbRow = table.DataTable().row(rowEl[0]);
                    let rowData = tbRow.data();
                    popup_open(`editor-${table.data('delete-and-reassign')}_replace`, rowData);
                    window.app_data.replace_id = null;
                    window.app_data.replace_reference = false;
                    window.app_data.delete_id = $(this).data('id');
                    window.app_data.table_id = $(this).parents('table').attr('id');
                    break;
                default:
                    break;
            }
        });
    }

    initCommandActions();

    $(dt.table().node()).on('keyup change', '.child :input', function (e) {
        var $el = $(this);
        var table = $el.closest('table').DataTable();
        var rowIdx = $el.closest('ul').data('dtr-index');
        var colIdx = $el.closest('li').data('dtr-index');
        var cell = table.cell({ row: rowIdx, column: colIdx }).node();
        $(':input', cell).val($el.val()).trigger("change");
        if ($el.is(':checked')) {
            $('input', cell).prop('checked', true).trigger("change");
        } else {
            $('input', cell).removeProp('checked').trigger("change");
        }
    });

    $(window).trigger("dataTableFinalized.limelight");
});

$(window).on("confirm.bs.popover", function (e, popover, confirm) {
    const ele = $(popover.element);

    // Archive action
    if (confirm && ele.data('type') === 'archive') {
        const table = ele.closest('.data-table');
        ele.closest('.datatable-command[data-type="archive"]').addClass('btn-loading').prop('disabled', true);
        ele.popover("dispose");
        popupAlert = undefined;
        $.ajax({
            url: table.data('archive'),
            method: 'POST',
            data: {
                dataTable: table.data('id'),
                id: ele.data('id')
            },
            dataType: 'json',
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    message(response['error'], 1);
                    return;
                }

                if (typeof response['message'] !== 'undefined') {
                    const msg = response.message;
                    message(msg);
                } else {
                    message('Record has been archived successfully!');
                }

                if (typeof response['dataTable']['data'] !== 'undefined') {
                    const data = response['dataTable']['data'][0];
                    const dtr = table.DataTable().row(table.find(`[data-id="${data['id']}"]`));
                    dtr.data(data).draw();
                }
            },
            error: function (response) {
                message('Error archiving record!', 1);
            },
            complete: function () {
                ele.closest('.datatable-command[data-type="archive"]').removeClass('btn-loading').prop('disabled', false);
            }
        });
        return;
    }

    // Unarchive action
    if (confirm && ele.data('type') === 'unarchive') {
        const table = ele.closest('.data-table');
        ele.closest('.datatable-command[data-type="unarchive"]').addClass('btn-loading-light').prop('disabled', true);
        ele.popover("dispose");
        popupAlert = undefined;
        $.ajax({
            url: table.data('unarchive'),
            method: 'POST',
            data: {
                dataTable: table.data('id'),
                id: ele.data('id')
            },
            dataType: 'json',
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    message(response['error'], 1);
                    return;
                }

                if (typeof response['message'] !== 'undefined') {
                    const msg = response.message;
                    message(msg);
                } else {
                    message('Record has been unarchived successfully!');
                }

                if (typeof response['dataTable']['data'] !== 'undefined') {
                    const data = response['dataTable']['data'][0];
                    const dtr = table.DataTable().row(table.find(`[data-id="${data['id']}"]`));
                    dtr.data(data).draw();
                }
            },
            error: function (response) {
                message('Error unarchiving record!', 1);
            },
            complete: function () {
                ele.closest('.datatable-command[data-type="unarchive"]').removeClass('btn-loading-light').prop('disabled', false);
            }
        });
        return;
    }

    // Sync action
    if (confirm && ele.data('type') === 'sync') {
        const table = ele.closest('.data-table');
        ele.popover("dispose");
        popupAlert = undefined;
        $.ajax({
            url: table.data('sync'),
            method: 'POST',
            data: {
                id: ele.data('id')
            },
            dataType: 'json',
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    message(response['error'], 1);
                    return;
                }

                if (typeof response['message'] !== 'undefined') {
                    const msg = response.message;
                    message(msg);
                } else {
                    message('Data has been synced successfully!');
                }
            },
            error: function (response) {
                message('Error syncing data!', 1);
            }
        });
        return;
    }

    // Unassign action
    if (confirm && ele.data('type') === 'unassign') {
        const table = ele.closest('.data-table');
        ele.popover("dispose");
        popupAlert = undefined;
        $.ajax({
            url: table.data('unassign'),
            method: 'POST',
            data: {
                id: ele.data('id'),
            },
            dataType: 'json',
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    message(response['error'], 1);
                    return;
                }

                $(window).trigger(table.data('unassign')+".success", [response]);

                if (typeof response['message'] !== 'undefined') {
                    const msg = response.message;
                    message(msg);
                } else {
                    message('Office has been unassigned successfully!');
                }

                let row = ele.closest("tr");
                if (row.hasClass("child")) row = row.prev();
                table.DataTable().row(row[0]).remove().draw();
            },
            error: function (response) {
                message('Error unassigning data!', 1);
            }
        });
        return;
    }
    if (confirm && ele.data('type') === 'unassign-contact') {
        const table = ele.closest('.data-table');
        ele.popover("dispose");
        popupAlert = undefined;
        $.ajax({
            url: table.data('unassign-contact'),
            method: 'POST',
            data: {
                contact_id: ele.data('id'),
                manager_id: ele.data('manager_id'),
                office_id: ele.data('office_id'),
            },
            dataType: 'json',
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    message(response['error'], 1);
                    return;
                }

                $(window).trigger(table.data('unassign-contact')+".success", [response]);

                if (typeof response['message'] !== 'undefined') {
                    const msg = response.message;
                    message(msg);
                } else {
                    message('Office has been unassigned successfully!');
                }

                let row = ele.closest("tr");
                if (row.hasClass("child")) row = row.prev();
                table.DataTable().row(row[0]).remove().draw();
            },
            error: function (response) {
                message('Error unassigning data!', 1);
            }
        });
        return;
    }

    // Delete
    if (confirm && ele.hasClass("datatable-command")) {
        var t = ele.closest(".data-table");
        message('Deleting..');
        $.ajax({
            url: t.data("delete"),
            method: "POST",
            data: {
                id: ele.data("id"),
            },
            dataType: 'json',
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    message(response['error'], 1);
                    return;
                }
                message('Record Deleted.');
                let row = ele.closest("tr");
                if (row.hasClass("child")) row = row.prev();
                t.DataTable().row(row[0]).remove().draw();
            },
            error: function (response) {
                message('Error Deleting Record!', 1);
            },
            complete: function () {

            }
        });
        ele.popover("dispose");
    } else if (confirm && ele.hasClass('link-command')) {
        message('Deleting..');
        $.ajax({
            url: ele.data("href"),
            method: "POST",
            data: {
                id: ele.data("id"),
            },
            dataType: 'json',
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    message(response['error'], 1);
                    return;
                }

                message('Record Deleted.');

                if (typeof response['redirect_to'] !== 'undefined') {
                    const element = document.createElement('a');
                    element.setAttribute('href', response['redirect_to']);
                    element.style.cssText = 'display:none;';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                    return;
                }

                window.location.reload();
            },
            error: function (response) {
                message('Error Deleting Record!', 1);
            },
            complete: function () {

            }
        });
        ele.popover("dispose");
    } else {
        ele.popover("dispose");
    }
});

$(window).on("form-success", function (e, response) {
    if (typeof response['dataTable'] !== 'undefined') {
        popup_close("editor-" + response['dataTable']['id']);
        var table = $("table[data-id='" + response['dataTable']['id'] + "']");

        if (!table.length) return;

        switch (response['method']) {
            case "create":
                var data = response['dataTable']['data'][0];
                var dt = table.DataTable();
                dt.row.add(data).draw();
                break;
            case "update":
                var data = response['dataTable']['data'][0];
                var dtr = table.DataTable().row(table.find("[data-id='" + data['id'] + "']"));
                dtr.data(data).draw();
                break;
            case "approved":
                var dtr = table.DataTable().row(table.find("[data-id='" + response['dataTable']['data_id'] + "']"));
                dtr.remove().draw();
                break;
            default:
                break;
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/dataTables.js